package com.yendo.mx.models

import kotlinx.serialization.Serializable

@Serializable
data class AppGlobalConfig(
    val mantenimiento_activo: Boolean = false,
    val mensaje_mantenimiento: String = "Estamos mejorando la plataforma. Volvemos en breve.",
    val app_usuario: AppPlataformaConfig = AppPlataformaConfig(),
    val app_comercio: AppPlataformaConfig = AppPlataformaConfig(),
    val app_repartidor: AppPlataformaConfig = AppPlataformaConfig(),
    val correo_soporte: String = "https://www.yendo.com.mx/ayuda", // Funciona como URL de ayuda general
    val url_terminos: String = "https://www.yendo.com.mx/terminos-y-condiciones",
    val url_privacidad: String = "https://www.yendo.com.mx/privacidad",
    val url_ayuda_pedido: String = "https://www.yendo.com.mx/ayuda",
    val banco_maestro: String = "",
    val beneficiario_maestro: String = "",
    val clabe_maestra: String = "",
    val url_articulos_prohibidos: String = "https://www.yendo.com.mx/articulos-prohibidos",
    
    // 🚀 CONFIGURACIÓN DE MÉTODOS DE ACCESO
    val auth_google_activo: Boolean = true,
    val auth_apple_activo: Boolean = true,
    val auth_telefono_activo: Boolean = true
)

@Serializable
data class AppPlataformaConfig(
    val android: VersionControlConfig = VersionControlConfig(),
    val ios: VersionControlConfig = VersionControlConfig()
)

@Serializable
data class VersionControlConfig(
    val min_version: Long = 1L,
    val latest_version: Long = 1L,
    val blacklisted_versions: List<Long> = emptyList(),
    val url_store: String = ""
)
